import { useQuery } from '@tanstack/react-query';
import shoppingProductService from 'v2/services/shopping/product';

export function useGetProductReviewCollector(productId: number) {
  return useQuery({
    queryKey: ['product-review-collector', productId],
    queryFn: () => shoppingProductService.getProductReviewCollector(productId)
  });
}
